// extracted by mini-css-extract-plugin
export default {"button":"style_button__DXa8G","processing":"style_processing__jgZYI","loader":"style_loader__0U4tL"};